import dropperIcon from 'assets/images/ingredients/eyedropper.svg';
import phoneIcon from 'assets/images/ingredients/phone.svg';
import reviewAndRefineIcon from 'assets/images/ingredients/reviewAndRefine.svg';

const howWorksContent = {
  haircare: {
    title: 'Personalization Works Better™',
    elements: [
      {
        title: 'Take our consultation',
        description:
          'We’ll analyze 80+ factors—from what you eat to where you live—to understand the unique needs of your hair.',
        asset: {
          icon: phoneIcon,
          alt: 'Smartphone',
        },
      },
      {
        title: 'Your formulas are made to order',
        description:
          'Our AI-powered algorithm personalizes your products + routine, carefully selecting from 185+ clean ingredients to meet your goals.',
        asset: {
          icon: dropperIcon,
          alt: 'Eyedropper',
        },
      },
      {
        title: 'as you change, so does your prose',
        description:
          'We’ll address any new concerns, adjust your formulas with the seasons, and learn from your feedback for an always-custom fit.',
        asset: {
          icon: reviewAndRefineIcon,
          alt: 'Sparkles',
        },
      },
    ],
  },
  skincare: {
    title: 'Personalization Works Better™',
    elements: [
      {
        title: 'Take our consultation',
        description:
          'We’ll analyze 80+ factors—from what you eat to where you live—to understand the unique needs of your skin.',
        asset: {
          icon: phoneIcon,
          alt: 'Smartphone',
        },
      },
      {
        title: 'Your formulas are made to order',
        description:
          'Our AI-powered algorithm personalizes your products + routine, carefully selecting from 185+ clean ingredients to meet your goals.',
        asset: {
          icon: dropperIcon,
          alt: 'Eyedropper',
        },
      },
      {
        title: 'as you change, so does your prose',
        description:
          'We’ll address any new concerns, adjust your formulas with the seasons, and learn from your feedback for an always-custom fit.',
        asset: {
          icon: reviewAndRefineIcon,
          alt: 'Sparkles',
        },
      },
    ],
  },
  haircareAndSkincare: {
    title: 'Custom care starts here',
    elements: [
      {
        title: 'Take our consultation',
        description:
          'We’ll analyze 80+ factors—from what you eat to where you live—to understand the unique needs of your hair or skin.',
        asset: {
          icon: phoneIcon,
          alt: 'Smartphone',
        },
      },
      {
        title: 'Your formulas are made to order',
        description:
          'Our AI-powered algorithm personalizes your products + routine, carefully selecting from 185+ clean ingredients to meet your goals.',
        asset: {
          icon: dropperIcon,
          alt: 'Eyedropper',
        },
      },
      {
        title: 'as you change, so does your prose',
        description:
          'We’ll address any new concerns, adjust your formulas with the seasons, and learn from your feedback for an always-custom fit.',
        asset: {
          icon: reviewAndRefineIcon,
          alt: 'Sparkles',
        },
      },
    ],
  },
};

export default howWorksContent;
